import { AdminNav } from "../mini-components/admin_nav"
import { useNavigate } from "react-router-dom"
import { AdminDogsDetailSearch } from "./adminDogDetailsSearch"
export const AdminDogsDetail = () =>
{
    const navigate = useNavigate()

    
    return (
        <div className="">
            <div>
                <AdminNav/>
            </div>

           <div>
             <AdminDogsDetailSearch />
             </div>

        </div>

    )
}